import React, { useEffect, useMemo, useState } from "react";

const AnswerPalette = ({ testDetail = {}, openSubmitModal, switchQuestion, attemptedQuestions = [], totalSection, currentSection, eachSectionQuestion, sectionNumbers, showSection }) => {
    const classGeneratorForSteps = (ind) => {
        if (attemptedQuestions[ind]?.questionId && !attemptedQuestions[ind]?.answer && attemptedQuestions[ind]?.isReview && attemptedQuestions[ind]?.currentSection == currentSection) {
            return "marked_for_review"
        }
        if (attemptedQuestions[ind]?.questionId && attemptedQuestions[ind]?.answer && attemptedQuestions[ind]?.isReview && attemptedQuestions[ind]?.currentSection == currentSection) {
            return "marked_for_review marked_for_review_with_dots"
        }
        if (attemptedQuestions[ind]?.isSave && attemptedQuestions[ind]?.currentSection == currentSection) {
            return 'answered'
        }
        if (attemptedQuestions[ind]?.isView && attemptedQuestions[ind]?.currentSection == currentSection) {
            return "not_answered"
        }
        return ''
    }
    const [sectionWiseQuestion, setSectionWiseQuestion] = useState([])
    // console.log(attemptedQuestions)
    const [totalAttempted, notAttempted, review, reviewWithAnswer] = useMemo(() => {
        const totalSave = attemptedQuestions.filter(item => item?.isSave && item?.currentSection == currentSection && item?.answer)?.length;
        const totalUnSave = attemptedQuestions.filter(item => item?.isView && item?.currentSection == currentSection && !item?.answer && !item?.isReview)?.length;
        const review = attemptedQuestions.filter(item => item?.isReview && item?.currentSection == currentSection && !item?.answer)?.length;
        const reviewWithAnswer = attemptedQuestions.filter(item => item?.isReview && item?.currentSection == currentSection && item?.answer)?.length;
        return [totalSave, totalUnSave, review, reviewWithAnswer]
    }, [attemptedQuestions])

    useEffect(() => {
        let totalQuestion = testDetail.questions.length;
        if (totalQuestion) {
            let eachSectionQuestion = totalQuestion / totalSection;
            let startIndex = currentSection * (eachSectionQuestion)
            let lastIndex = eachSectionQuestion * (currentSection + 1)
            for (let i = 0; i < totalSection; i++) {
                setSectionWiseQuestion(testDetail.questions.slice(startIndex, lastIndex))
            }
        }
    }, [testDetail.questions, totalSection, currentSection])
    return (
        <>
            <div className="answer_palette_wrapper">
                <div className="answer_indicator">
                    <ul type="none" className="d-flex flex-wrap align-items-center">
                        <li>
                            <span className="answered">{totalAttempted}</span> Answered
                        </li>
                        <li>
                            <span className="not_answered">{notAttempted}</span> Not Answered
                        </li>
                        <li>
                            <span>{
                                sectionWiseQuestion?.length - (totalAttempted + notAttempted + review + reviewWithAnswer)
                            }</span> Not Visited
                        </li>
                        <li>
                            <span className="marked_for_review">{review}</span> Marked for Review
                        </li>
                        <li>
                            <span className="marked_for_review marked_for_review_with_dots">{reviewWithAnswer}</span> Answered & Marked for Review (will be considered for evaluation)
                        </li>
                    </ul>
                </div>
                <div className="course_name">
                    {
                        !showSection &&
                        <p>All Questions</p>
                    }
                    {
                        showSection &&
                        <p>Section {sectionNumbers[currentSection]} ({eachSectionQuestion} Questions)</p>
                    }

                </div>
                <div className="question_number_palellet">
                    <p>Choose a Question</p>
                    <div className="question_numbers">
                        {
                            sectionWiseQuestion.map((d, i) => (
                                // response= storedResponse[i]                                           
                                <span key={d._id} className={classGeneratorForSteps((currentSection * eachSectionQuestion) + i)}
                                    onClick={() => switchQuestion(i, d._id)}
                                >{(i + 1)}</span>
                            ))
                        }

                    </div>
                </div>
            </div>
            <div className="submit_button text-center">
                {
                    totalSection > 1 && currentSection != (totalSection - 1) &&
                    <p>You will be moved to next section automatically after current section timer gets over.</p>
                }
                {
                    totalSection > 1 && currentSection == (totalSection - 1) &&
                    <p>Test will be auto submitted when timer gets off.</p>
                }
                {
                    totalSection <= 1 &&
                    <button className="btn btn_submit" type="submit" onClick={openSubmitModal}>Submit</button>
                }
                {/* <button className="btn btn_submit" type="submit" onClick={openSubmitModal}>Submit</button> */}
            </div>
        </>
    )
}

export default AnswerPalette;